<div class="tt-c-summary-dim tt-c-summary-dim-range tt-u-spacing--sm">
  <div class="tt-c-summary-dim__heading" role="heading" :aria-level="headingLevel"><slot></slot></div>
  <div class="tt-c-summary-dim-range__bar-wrap">
    <div class="tt-c-summary-dim-range__bar"><span ref="dot" class="tt-c-summary-dim-range__dot" :style="{ left: dotPositionPercentage }"></span></div>
    <div class="tt-u-clip-hide" v-html="description"></div>
  </div>
  <div class="tt-c-summary-dim-range__option-labels">
    <span v-for="vLabel in valueLabels" class="tt-c-summary-dim__text tt-c-summary-dim__text--spaced" aria-hidden="true">{{vLabel}}</span>
  </div>
</div>
